import { orchestrator } from 'satcheljs';
import { resetQuickCompose } from 'owa-calendar-compose-form-actions';
import { lazyShowQuickCompose } from 'owa-calendar-compose-form-store';

export default orchestrator(resetQuickCompose, actionMessage => {
    lazyShowQuickCompose.importAndExecute(
        actionMessage.anchor,
        actionMessage.entrySource,
        actionMessage.viewType,
        actionMessage.event
    );
});
